<template>
  <div class="about-page">
    <!-- 页眉部分 -->
    <Header></Header>

    <!-- 导航菜单 -->
    <Nav></Nav>

    <!-- 英雄区域 -->
    <div class="hero">
      <div class="hero-content">
        <h1>{{ $t("about.heroTitle") }}</h1>
        <p>{{ $t("about.heroSubtitle") }}</p>
      </div>
    </div>

    <!-- 上半部分：团队主任联系方式 + 实验室简介 -->
    <div class="main-content">
      <div class="about-container">
        <div class="contact-info">
          <h3 class="contact-title">{{ $t("about.directorContact") }}</h3>
          <template v-if="directorLoading">
            <div class="contact-item" v-for="n in 5" :key="'dc-' + n">
              <span class="skeleton-title" style="width:100%;height:14px;display:block;margin-bottom:10px;background:linear-gradient(90deg,#f0f0f0 25%,#e0e0e0 50%,#f0f0f0 75%);background-size:200% 100%;animation:shimmer 1.5s infinite;border-radius:4px;"></span>
            </div>
          </template>
          <template v-else-if="directorError">
            <p style="color:#999;">加载失败</p>
          </template>
          <template v-else-if="director">
            <div class="contact-item">
              <span class="contact-label">{{ $t("about.name") }}</span>
              <span>{{ director.name }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("about.title") }}</span>
              <span>{{ director.title }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("about.email") }}</span>
              <span>{{ director.email }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("about.office") }}</span>
              <span>{{ director.office }}</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">{{ $t("about.officeHours") }}</span>
              <span>{{ director.officeHours }}</span>
            </div>
          </template>
        </div>

        <div class="about-intro">
          <h2>{{ $t("about.labIntro") }}</h2>
          <p v-for="item in intro" :key="item">{{ item }}</p>
        </div>
      </div>
    </div>

    <!-- 下半部分：研究方向 -->
    <div class="research-section">
      <h2 class="research-section-title">{{ $t("about.researchDirections") }}</h2>

      <div class="research-directions">
        <p>{{ $t("about.researchIntro") }}</p>
        <div class="direction-list">
          <div
            class="direction-item"
            v-for="(d, idx) in directions"
            :key="idx"
            @click="openPlatform(d)"
          >
            <div class="direction-link">
              <h3 class="direction-title">{{ d.title }}</h3>
              <p>{{ d.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平台弹窗 -->
    <div class="modal-overlay" v-if="modalActive" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <h3 class="modal-title">{{ selectedPlatform.title }}</h3>
          <button class="modal-close" @click="closeModal">×</button>
        </div>
        <div class="modal-body">
          <p>{{ selectedPlatform.desc }}</p>
          <div class="modal-results"></div>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <Footer></Footer>
  </div>
</template>

<script>
import defaultLogo from "@/assets/default-logo.png";
import Header from "../../components/head.vue";
import Nav from "../../components/nav.vue";
import Footer from "../../components/footer.vue";
import { GetAboutData } from "../../api/about";
import { getDirectorContact } from "../../api/home";

export default {
  name: "AboutPage",
  components: { Header, Nav, Footer },
  data() {
    return {
      intro: [],
      labLogo: "lab-logo.png",
      uestcLogo: "uestc-logo.png",
      uestcSzLogo: "uestc-sz-logo.png",
      defaultLogo: defaultLogo,
      directions: [],
      modalActive: false,
      selectedPlatform: {},
      director: null,
      directorRaw: null,
      directorLoading: true,
      directorError: false,
    };
  },
  methods: {
    setDefaultLogo(event) {
      // 与首页一致的实现：当图片加载失败时，替换为 defaultLogo
      event.target.src = defaultLogo;
    },
    openPlatform(platform) {
      this.selectedPlatform = platform;
      this.modalActive = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.modalActive = false;
      this.selectedPlatform = {};
      document.body.style.overflow = "";
    },
    async getIntroData() {
      let category = {
        category: "intro",
      };
      let res = await GetAboutData(category);
      if (res.code === 0) {
        this.intro = res.rows[0].descriptionsArr;
      }
    },
    async getDirectionData() {
      let category = {
        category: "direction",
      };
      let res = await GetAboutData(category);
      if (res.code === 0) {
        let directiondata = res.rows;
        for (let i = 0; i < directiondata.length; i++) {
          this.directions.push({
            title: directiondata[i].title,
            desc: directiondata[i].description,
          });
        }
      }
    },
    async getDirectorContactData() {
      this.directorLoading = true;
      this.directorError = false;
      try {
        let res = await getDirectorContact();
        if (res.code === 0 && res.data) {
          this.directorRaw = res.data;
          this.applyDirectorLang();
        } else {
          this.directorError = true;
        }
      } catch (e) {
        this.directorError = true;
      }
      this.directorLoading = false;
    },
    applyDirectorLang() {
      if (!this.directorRaw) return;
      const lang = this.$i18n.locale || "zh";
      const d = this.directorRaw;
      this.director = {
        name: lang === "en" ? d.nameEn : d.nameZh,
        title: lang === "en" ? d.titleEn : d.titleZh,
        email: d.email,
        office: lang === "en" ? d.officeEn : d.officeZh,
        officeHours: lang === "en" ? d.officeHoursEn : d.officeHoursZh,
      };
    },
  },
  watch: {
    "$i18n.locale"() {
      this.applyDirectorLang();
    },
  },
  mounted() {
    this.getIntroData();
    this.getDirectionData();
    this.getDirectorContactData();
  },
};
</script>

<style scoped>
.hero {
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="400"><rect width="1200" height="400" fill="%23004080"/><circle cx="200" cy="150" r="50" fill="%23FFD700" opacity="0.3"/><circle cx="800" cy="250" r="80" fill="%23FFD700" opacity="0.2"/><rect x="400" y="100" width="300" height="200" fill="%23FFD700" opacity="0.1"/></svg>');
  background-size: cover;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
}
.hero-content h1 {
  font-size: 2.5em;
  margin-bottom: 20px;
}
.hero-content p {
  font-size: 1.1em;
}

/* ==================== 上半部分主体内容 ==================== */
.main-content {
  max-width: 1000px;
  margin: 40px auto;
  padding: 0 20px;
}
.about-container {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  align-items: flex-start;
}
.contact-info {
  flex: 1 1 250px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
.contact-title {
  color: #004080;
  font-weight: bold;
  margin-bottom: 15px;
  border-bottom: 2px solid #004080;
  padding-bottom: 10px;
}
.contact-item {
  margin-bottom: 15px;
}
.contact-label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  color: #004080;
}
.about-intro {
  flex: 2 1 600px;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.06);
}

.about-intro h2 {
  color: #003366;
  font-size: 1.8em;
  margin-bottom: 20px;
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 2px solid #004080;
}

.about-intro p {
  margin-bottom: 1rem;
}

/* ==================== 下半部分：研究方向 ==================== */
.research-section {
  max-width: 1000px;
  margin: 40px auto;
  padding: 20px;
  background: #f7f8fa;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.research-section-title {
  color: #003366;
  font-size: 1.8em;
  text-align: center;
  margin-top: 0;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #004080;
}

/* 研究方向 */
.direction-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 20px;
}
.research-directions {
  text-align: center;
}

.research-directions p {
  margin: 1rem 0;
}

.direction-item {
  background: #fff;
  padding: 16px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.direction-item h3 {
  transition: color 0.3s ease;
}
.direction-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}
.direction-item:hover h3 {
  color: #ffd700;
}

/* ==================== 模态框 ==================== */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.modal-container {
  background: #fff;
  width: 90%;
  max-width: 820px;
  border-radius: 8px;
  overflow: hidden;
}
.modal-header {
  background: #003366;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-body {
  padding: 20px;
}
.modal-close {
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

/* ==================== 响应式 ==================== */
@media (max-width: 768px) {
  .about-container {
    flex-direction: column;
  }
  .research-section {
    padding: 15px;
  }
}
</style>
